export default __webpack_public_path__ + "static/media/VoteGuide.ab14c06a.svg";